import { Component, Input, NgModule } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { switchMap, mapTo, startWith, scan, takeWhile } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
class NgAnimatedCounter {
    constructor() {
        this.current = 0;
        this._counterSubject$ = new Subject();
    }
    set params(value) {
        if (this._counterSubscription) {
            this._counterSubscription.unsubscribe();
        }
        this.current = value.start;
        this._counterSubscription = this._counterSubject$
            .pipe(switchMap(end => {
            return timer(0, value.interval)
                .pipe(mapTo(this.positiveOrNegative(end, this.current)), startWith(this.current), scan((acc, curr) => {
                if (value.increment) {
                    return acc + value.increment;
                }
                return acc + curr;
            }), takeWhile(this.isApproachingRange(end, this.current)));
        }))
            .subscribe((val) => this.current = val);
        this._counterSubject$.next(value.end);
    }
    ngOnDestroy() {
        if (this._counterSubscription) {
            this._counterSubscription.unsubscribe();
        }
    }
    positiveOrNegative(endRange, currentNumber) {
        return endRange > currentNumber ? 1 : -1;
    }
    isApproachingRange(endRange, currentNumber) {
        return endRange > currentNumber
            ? val => val <= endRange
            : val => val >= endRange;
    }
}
NgAnimatedCounter.ɵfac = function NgAnimatedCounter_Factory(t) { return new (t || NgAnimatedCounter)(); };
NgAnimatedCounter.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgAnimatedCounter, selectors: [["ng-animated-counter"]], inputs: { params: "params" }, decls: 2, vars: 1, template: function NgAnimatedCounter_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span");
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.current, "\n");
    } } });
NgAnimatedCounter.propDecorators = {
    params: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgAnimatedCounter, [{
        type: Component,
        args: [{ selector: 'ng-animated-counter', template: "<span>\n    {{current}}\n</span>" }]
    }], function () { return []; }, { params: [{
            type: Input
        }] }); })();

class NgAnimatedCounterModule {
}
NgAnimatedCounterModule.ɵfac = function NgAnimatedCounterModule_Factory(t) { return new (t || NgAnimatedCounterModule)(); };
NgAnimatedCounterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgAnimatedCounterModule });
NgAnimatedCounterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgAnimatedCounterModule, [{
        type: NgModule,
        args: [{
                declarations: [NgAnimatedCounter],
                exports: [NgAnimatedCounter]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgAnimatedCounterModule, { declarations: [NgAnimatedCounter], exports: [NgAnimatedCounter] }); })();

/*
 * Public API Surface of @bugsplat/ng-animated-counter
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgAnimatedCounter, NgAnimatedCounterModule };

